var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortugalFlag(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 40,
    viewBox: "0 0 64 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e50a0;stroke:#1e50a0;}.cls-1,.cls-2,.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-4,.cls-5{fill:none;}.cls-2,.cls-5{stroke:#fcea2b;}.cls-6{fill:#d22f27;}.cls-7{fill:#5c9e31;}.cls-3{fill:#fff;stroke:#d22f27;}.cls-3,.cls-4,.cls-5{stroke-width:2px;}.cls-4{stroke:#000;}.cls-5{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1,
    y: 1,
    width: 62,
    height: 38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1,
    y: 1,
    width: 21,
    height: 38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 22,
    cy: 20,
    r: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 22,
    y1: 8,
    x2: 22,
    y2: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "22 23.5 13 28 31 28 22 23.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "22 17.5 31 12 22.5 13.5 13 12 22 17.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "34 20 22 25 10 20 22 15 34 20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.2,13h11.6v10.1c0,2.5-2.6,4.6-5.8,4.6h0c-3.2,0-5.8-2.1-5.8-4.6V13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22,
    cy: 16.8,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22,
    cy: 22.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22,
    cy: 19.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 19.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 19,
    cy: 19.7,
    r: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1,
    y: 1,
    width: 62,
    height: 38
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortugalFlag);
export default __webpack_public_path__ + "static/media/portugal-flag.05f7a49f33594e8acdc71b660d4ea59c.svg";
export { ForwardRef as ReactComponent };